import React, {useContext, useEffect, useState} from "react";
import { Route, Switch } from "react-router-dom";
import $ from "jquery";
import usePrevious from "../../../../class/tool/usePrevious";
import HeaderAccess from "../../header/HeaderAccess";
import ObjectSheet from "../../../sheet/ObjectSheet";
import AccountList from "../../../overbox/account/AccountList";
import LoaderCircle from "../../../loader/LoaderCircle";
import SessionContext from "../../../../context/SessionContext";
import "../../../../css/page/content/access/Access.css";

const Access = () => {
    const {handleCheckBigBisoux, handleSwitch} = useContext(SessionContext);
    const [companies, setCompanies] = useState([]);
    const [stores, setStores] = useState([]);
    const [nbCompanies, setNbCompanies] = useState(null);
    const [nbStores, setNbStores] = useState(null);
    const prevNbCompanies = usePrevious(nbCompanies);
    const prevNbStores = usePrevious(nbStores);
    const EVOL_PERCENT = 15;

    const buildEnv = () => {
        const env = JSON.parse(localStorage.getItem("originEnv"));

        switch (env.type) {
            case "empire":
                let companiesTmp = [];
                let storesTmp = [];

                try {
                    for (let i in env.companies) {
                        if (env.companies[i].name !== null) {
                            let company = Object.assign({}, env.companies[i]);
                            company.loading = false;
                            companiesTmp.push(company);
                        }
                        else {
                            for (let j in env.companies[i].stores) {
                                let store = Object.assign({}, env.companies[i].stores[j]);
                                store.loading = false;
                                storesTmp.push(store);
                            }
                        }
                    }

                    for (let i in companiesTmp) {
                        for (let j in companiesTmp[i].stores) {
                            let store = Object.assign({}, companiesTmp[i].stores[j]);
                            store.loading = false;
                            storesTmp.push(store);
                        }
                    }
                }
                catch (e) {}

                setCompanies(companiesTmp);
                setStores(storesTmp);

                break;
            default: break;
        }
    }
    const controlNumbers = () => {
        evolInteger("nbCompanies", nbCompanies, prevNbCompanies);
        evolInteger("nbStores", nbStores, prevNbStores);
    }
    const evolInteger = (id, value, prevValue) => {
        let prev, delta, step, loop;

        if (value !== null && prevValue !== undefined && parseInt(value) !== parseInt(prevValue)) {
            try {
                loop = 1;
                prev = prevValue !== null ? prevValue : 0;
                delta = Math.abs(parseInt(value) - parseInt(prev));
                step = delta > 1 ? Math.round(((EVOL_PERCENT * delta) / 100)) : 1;

                if (delta > 0 && step === 0)
                    step = 1;

                if (Math.abs(delta) === 0) return;

                if (parseInt(value) >= parseInt(prev)) {
                    for (let i = parseInt(prev); i <= parseInt(value); i = i + step) {
                        if (i > parseInt(value))
                            i = parseInt(value);

                        setTimeout(() => { $("#" + id + " > strong").text(i); }, loop*100);

                        loop++;
                    }
                }
                else {
                    for (let i = parseInt(prev); i <= parseInt(value); i = i - step) {
                        if (i < parseInt(value))
                            i = parseInt(value);

                        setTimeout(() => { $("#" + id + " > strong").text(i); }, loop*100);

                        loop++;
                    }
                }

                setTimeout(() => { $("#" + id + " > strong").text(parseInt(value)); }, loop*100);
            }
            catch (error) {}
        }
    }
    const handleSelectCompany = company => {
        let companiesTmp = companies.slice();
        let index = companiesTmp.findIndex(_ => _.id === company.id);

        if (index >= 0) {
            companiesTmp[index].loading = true;
            setCompanies(companiesTmp);
        }

        handleSwitch('company', company.id);
    }
    const handleSelectStore = store => {
        let storesTmp = stores.slice();
        let index = storesTmp.findIndex(_ => _.id === store.id);

        if (index >= 0) {
            storesTmp[index].loading = true;
            setStores(storesTmp);
        }

        handleSwitch('store', store.id);
    }

    useEffect(() => {
        document.title = "Mes boutiques";

        buildEnv();
        handleCheckBigBisoux();
    }, []);
    useEffect(() => {
        setNbCompanies(companies.length);
        setNbStores(stores.length);
    }, [companies, stores]);
    useEffect(() => {
        controlNumbers();
    }, [nbCompanies, nbStores]);

    return (
        <div className="mainAccess">
            <HeaderAccess />
            <div className={"summary"}>
                <div className={"keyStat"}>
                    <div className={"containerValue"}>
                        <p className={"titleStat"}>Droits groupes</p>
                        <p className={"valueStat"} id={"nbCompanies"}><strong>0</strong></p>
                    </div>
                </div>
                <div className={"keyStat noRight"}>
                    <div className={"containerValue"}>
                        <p className={"titleStat"}>Droits boutiques</p>
                        <p className={"valueStat"} id={"nbStores"}><strong>0</strong></p>
                    </div>
                </div>
            </div>
            {
                companies.length > 0
                && <div className={"containerCompanies"}>
                    {
                        companies.map((company, index) => (
                            <div className={"company"} key={index}>
                                <p className={"name"}>Groupe {company.name.toLocaleUpperCase()}</p>
                                <p className={"nbStores"}>{company.stores.length} boutique{(company.stores.length > 1 ? "s" : "")}</p>
                                <p className={"access"} onClick={() => { handleSelectCompany(company); }}>
                                    {
                                        company.loading
                                            ? <LoaderCircle />
                                            : "Accéder au groupe"
                                    }
                                </p>
                            </div>
                        ))
                    }
                </div>
            }
            {
                companies.length > 0
                && <p className={"storesPart"}>Boutiques</p>
            }
            {
                stores.length > 0
                && <div className={"containerStores"}>
                    {
                        stores.map((store, index) => (
                            <div className={"store"} key={index}>
                                {
                                    store.company.name !== null
                                    && <p className={"company"}>{store.company.name.toLocaleUpperCase()}</p>
                                }
                                <p className={"name" + (store.company.name !== null ? " withCompany" : "")}>Boutique {store.shortName.toLocaleUpperCase()}</p>
                                <p className={"address"}>{store.address.toLocaleLowerCase()}</p>
                                <p className={"city"}>{store.postalCode} {store.city}</p>
                                <p className={"access"} onClick={() => { handleSelectStore(store); }}>
                                    {
                                        store.loading
                                            ? <LoaderCircle />
                                            : "Accéder à la boutique"
                                    }
                                </p>
                            </div>
                        ))
                    }
                </div>
            }
            <Switch>
                <Route path="/access/stores/:id/informations">
                    <ObjectSheet objectType="store" />
                </Route>
                <Route path="/access/stores/:id/accounts">
                    <AccountList />
                </Route>
            </Switch>
        </div>
    );
}

export default Access;